import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-clock",
  "use": "icon-si-glyph-clock-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol viewBox=\"0 0 17 17\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-clock\" id=\"icon-si-glyph-clock\"><title>918</title><defs></defs><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(1.000000, 1.000000)\" fill=\"#434343\"><path d=\"M8.008,15.929 C3.623,15.929 0.058,12.366 0.058,7.987 C0.058,3.606 3.623,0.043 8.008,0.043 C12.392,0.043 15.958,3.606 15.958,7.987 C15.958,12.365 12.392,15.929 8.008,15.929 L8.008,15.929 L8.008,15.929 Z M7.973,1.863 C4.619,1.863 1.889,4.605 1.889,7.974 C1.889,11.343 4.619,14.085 7.973,14.085 C11.328,14.085 14.058,11.343 14.058,7.974 C14.058,4.605 11.328,1.863 7.973,1.863 L7.973,1.863 L7.973,1.863 Z\" class=\"si-glyph-fill\" /><rect x=\"7\" y=\"4\" width=\"0.959\" height=\"3.978\" class=\"si-glyph-fill\" /><rect x=\"7\" y=\"8\" width=\"3.938\" height=\"0.979\" class=\"si-glyph-fill\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-clock.svg
// module id = /On/
// module chunks = 62